// Imports GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

// Import alpineJS
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

// Register plugins
gsap.registerPlugin(ScrollTrigger, SplitText);
Alpine.plugin(collapse);

// // Initialize Alpine
window.Alpine = Alpine;
Alpine.start();

// Import scripts
import { emblaHeroCarousel } from "./embla-carousels/embla-hero-carousel";
import { fadeKeyNumbers } from "./gsap-animations/fade-key-numbers";
import { fadeUpCards } from "./gsap-animations/fade-up-cards";
import { fadeUp } from './gsap-animations/fade-up';
import { fadeImageDarkness } from './gsap-animations/fade-image-darkness';
import { filter } from './gsap-animations/filter';
import { scale } from "./gsap-animations/scale";
import { emblaMobileSlider } from "./embla-carousels/embla-mobile-slider";
import { modal } from "./gsap-animations/modal";
import { widthHover } from "./gsap-animations/width-hover";
import { teaserInteractive } from "./gsap-animations/teaser-interactive";
import { mask } from "./gsap-animations/mask";
import { postsListingSearch } from "./posts-listing-search";
import { scrollTop } from "./scroll-top";
import { handleAnchor } from "./handle-anchor";

document.addEventListener('DOMContentLoaded', () => {
  emblaHeroCarousel();
  fadeKeyNumbers();
  fadeUpCards();
  fadeUp();
  fadeImageDarkness();
  filter();
  scale();
  emblaMobileSlider();
  modal();
  widthHover();
  teaserInteractive();
  mask();
  postsListingSearch();
  scrollTop();
  handleAnchor();
});
